import { ImportManagementHistory } from "../../VerificationAgency/VerificationProcess/VAClientImportManagement/ImportManagementHistory";

export const PayrollImportHistory = () => {
    return <ImportManagementHistory isPayrollImport={true} />;
}
